import { render, staticRenderFns } from "./workload-type-summary.vue?vue&type=template&id=78f706a8&"
import script from "./workload-type-summary.vue?vue&type=script&lang=js&"
export * from "./workload-type-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports